const STORAGE_PREFIX = 'kostu:approved-program-outcomes:v1:';

const storageKey = (programId) => `${STORAGE_PREFIX}${String(programId)}`;

const normalizeOutcomes = (outcomes) => {
  if (!Array.isArray(outcomes) || outcomes.length === 0 || outcomes.length > 13) return null;

  const seenNames = new Set();
  const normalized = [];
  for (let index = 0; index < outcomes.length; index += 1) {
    const name = String(outcomes[index]?.name || '').trim();
    if (!name || name.length > 2000) return null;
    const normalizedName = name.replace(/\s+/g, ' ').toLocaleLowerCase('tr-TR');
    if (seenNames.has(normalizedName)) return null;
    seenNames.add(normalizedName);
    normalized.push({ number: index + 1, name });
  }
  return normalized;
};

export const readApprovedProgramOutcomes = (programId) => {
  if (programId == null || typeof window === 'undefined') return null;
  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey(programId)) || 'null');
    const outcomes = normalizeOutcomes(parsed?.outcomes);
    if (!outcomes || Number(parsed?.programId) !== Number(programId)) return null;
    return Object.freeze({
      version: 1,
      programId: Number(programId),
      programName: String(parsed?.programName || '').trim(),
      approvedAt: String(parsed?.approvedAt || ''),
      updatedAt: String(parsed?.updatedAt || ''),
      outcomes: Object.freeze(outcomes.map((outcome) => Object.freeze(outcome))),
    });
  } catch (error) {
    return null;
  }
};

export const approveProgramOutcomes = (programId, programName, outcomes) => {
  if (programId == null || typeof window === 'undefined') {
    return { ok: false, error: 'Program bilgisi bulunamadı.' };
  }

  const existing = readApprovedProgramOutcomes(programId);
  if (existing) return { ok: true, snapshot: existing, created: false };

  const normalized = normalizeOutcomes(outcomes);
  if (!normalized) {
    return { ok: false, error: 'Onaylanacak program çıktıları geçersiz.' };
  }

  const snapshot = {
    version: 1,
    programId: Number(programId),
    programName: String(programName || '').trim(),
    approvedAt: new Date().toISOString(),
    outcomes: normalized,
  };

  try {
    window.localStorage.setItem(storageKey(programId), JSON.stringify(snapshot));
    const stored = readApprovedProgramOutcomes(programId);
    if (!stored) throw new Error('Onaylı liste doğrulanamadı.');
    return { ok: true, snapshot: stored, created: true };
  } catch (error) {
    return {
      ok: false,
      error: 'Onaylı program çıktıları bu tarayıcıda saklanamadı. Tarayıcı depolama iznini kontrol edin.',
    };
  }
};

export const updateApprovedProgramOutcomes = (programId, programName, outcomes) => {
  if (programId == null || typeof window === 'undefined') {
    return { ok: false, error: 'Program bilgisi bulunamadı.' };
  }

  const current = readApprovedProgramOutcomes(programId);
  if (!current) {
    return { ok: false, error: 'Düzenlenecek program çıktısı listesi bulunamadı.' };
  }

  const normalized = normalizeOutcomes(outcomes);
  if (!normalized) {
    return { ok: false, error: 'Program çıktıları boş, yinelenen veya geçersiz olamaz.' };
  }

  const snapshot = {
    version: 1,
    programId: Number(programId),
    programName: String(programName || current.programName || '').trim(),
    approvedAt: current.approvedAt,
    updatedAt: new Date().toISOString(),
    outcomes: normalized,
  };

  try {
    window.localStorage.setItem(storageKey(programId), JSON.stringify(snapshot));
    const stored = readApprovedProgramOutcomes(programId);
    if (!stored) throw new Error('Güncellenen liste doğrulanamadı.');
    return { ok: true, snapshot: stored };
  } catch (error) {
    return { ok: false, error: 'Program çıktıları güncellenemedi. Lütfen tekrar deneyin.' };
  }
};
